import { motion } from 'framer-motion'
import { Mail, Phone, MapPin, Linkedin, Twitter, Facebook } from 'lucide-react'

const Footer = () => {
  const socialLinks = [
    { icon: Linkedin, href: '#', label: 'LinkedIn' },
    { icon: Twitter, href: '#', label: 'Twitter' },
    { icon: Facebook, href: '#', label: 'Facebook' },
  ]

  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-secondary border-t" id="contact">
      <div className="section-container py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-primary to-accent rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-xl">D</span>
              </div>
              <span className="text-foreground font-display font-bold text-xl">
                Dia Industries<span className="text-primary">.IoT</span>
              </span>
            </div>
            <p className="text-muted-foreground mb-6">
              The Future of Industrial Autonomy. Connected Intelligence for Industry 4.0.
            </p>
            <div className="flex space-x-4">
              {socialLinks.map((social) => (
                <motion.a
                  key={social.label}
                  href={social.href}
                  className="w-10 h-10 bg-secondary rounded-full flex items-center justify-center text-muted-foreground hover:text-primary hover:bg-primary/10 transition-all border"
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.9 }}
                >
                  <social.icon size={18} />
                </motion.a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-foreground font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-3">
              {['Products', 'Technology', 'ROI', 'About'].map((item) => (
                <li key={item}>
                  <a
                    href={`#${item.toLowerCase()}`}
                    className="text-muted-foreground hover:text-primary transition-colors"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Products */}
          <div>
            <h3 className="text-foreground font-semibold mb-4">Products</h3>
            <ul className="space-y-3">
              {[
                'Smart Energy Node',
                'Smart Water Digitizer',
                'AI-Retail Guard',
                'Industrial Robotics',
              ].map((item) => (
                <li key={item}>
                  <a
                    href="#products"
                    className="text-muted-foreground hover:text-primary transition-colors"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-foreground font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <Mail className="text-primary mt-1 flex-shrink-0" size={18} />
                <span className="text-muted-foreground">diaindustriesiot.com</span>
              </li>
              <li className="flex items-start space-x-3">
                <Phone className="text-primary mt-1 flex-shrink-0" size={18} />
                <span className="text-muted-foreground">+216 23 486 874</span>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="text-primary mt-1 flex-shrink-0" size={18} />
                <span className="text-muted-foreground">Tunisia, MENA Region</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-muted-foreground text-sm">
              © {currentYear} Dia Industries IoT. All rights reserved.
            </p>
            <p className="text-muted-foreground text-sm">
              "Join us in leading the Connected Intelligence revolution"
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
